module.exports = __webpack_public_path__ + "static/media/pinnacles.bfe5afdb.png";